import * as React from "react";

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 10.828 8.364" {...props}>
      <path data-name="Line 204" fill="none" stroke={props.color} strokeLinecap="round" strokeWidth={2} d="M3.914 6.949l-2.5-2.535" />
      <path data-name="Line 205" fill="none" stroke={props.color} strokeLinecap="round" strokeWidth={2} d="M9.414 1.414l-5.5 5.535" />
    </svg>
  );
}

export default SvgComponent;
